import React from 'react';

const TAG_COLORS = [
  { bg: 'rgba(59,130,246,0.15)',  border: 'rgba(59,130,246,0.45)',  text: '#60a5fa'  }, // blue
  { bg: 'rgba(34,197,94,0.15)',   border: 'rgba(34,197,94,0.45)',   text: '#4ade80'  }, // green
  { bg: 'rgba(245,158,11,0.15)',  border: 'rgba(245,158,11,0.45)',  text: '#fbbf24'  }, // amber
  { bg: 'rgba(239,68,68,0.15)',   border: 'rgba(239,68,68,0.45)',   text: '#f87171'  }, // red
  { bg: 'rgba(139,92,246,0.15)',  border: 'rgba(139,92,246,0.45)',  text: '#a78bfa'  }, // purple
  { bg: 'rgba(6,182,212,0.15)',   border: 'rgba(6,182,212,0.45)',   text: '#22d3ee'  }, // cyan
  { bg: 'rgba(244,114,182,0.15)', border: 'rgba(244,114,182,0.45)', text: '#f472b6'  }, // pink
  { bg: 'rgba(16,185,129,0.15)',  border: 'rgba(16,185,129,0.45)',  text: '#34d399'  }, // emerald
];

export function getTagColor(tag) {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) hash = tag.charCodeAt(i) + ((hash << 5) - hash);
  return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length];
}

export function parseTags(raw) {
  if (!raw) return [];
  return raw.split(';').map(t => t.trim()).filter(Boolean);
}

export default function TagBadge({ tag, onRemove, small }) {
  const c = getTagColor(tag);
  return (
    <span
      className={`tag-badge${small ? ' tag-badge-sm' : ''}`}
      style={{ background: c.bg, border: `1px solid ${c.border}`, color: c.text }}
    >
      {tag}
      {onRemove && (
        <button className="tag-remove-btn" onClick={() => onRemove(tag)} title={`Remover tag "${tag}"`}>✕</button>
      )}
    </span>
  );
}
